import React from 'react'
import { CellCompProps } from '../Table'

const BaseCell = <T extends {}> ({ row, col }: CellCompProps<T>) => {
  const val = row[col.name]
  return (
    <div title={val} className={`cell ${col.name}`}>
      {val}
    </div>
  )
}

export default BaseCell
